import { useLanguage } from "../i18n/LanguageContext";
import { services, WHATSAPP_NUMBER } from "../content/siteContent";
import { Reveal, Overline } from "./Reveal";
import { ServiceIcon, IconWhatsApp } from "./Icons";

const ServicesSection = () => {
    const { t, lang } = useLanguage();
    return (
        <section id="services" className="scroll-mt-24 bg-tint/60 py-12 md:py-20" aria-labelledby="services-title" data-testid="services-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl">
                    <Overline>{t.services.overline}</Overline>
                    <h2 id="services-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        {t.services.title}
                    </h2>
                    <p className="mt-4 text-base leading-relaxed text-mist md:text-lg">{t.services.subtitle}</p>
                </Reveal>
                <div className="mt-12 grid gap-4 sm:grid-cols-2 md:mt-16 md:gap-6 lg:grid-cols-3">
                    {services.map((s, i) => (
                        <Reveal key={s.id} delay={Math.min(i * 0.05, 0.35)} y={20}>
                            <article
                                data-testid={`service-card-${s.id}`}
                                className="group h-full rounded-2xl border border-ink/10 bg-surface p-6 shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-gold-500/50 hover:shadow-[0_24px_45px_-25px_rgba(0,77,77,0.4)] md:p-7"
                            >
                                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gold-100 text-gold-600 transition-[transform,background-color,color] duration-300 group-hover:scale-110 group-hover:bg-gold-500 group-hover:text-ink">
                                    <ServiceIcon name={s.icon} />
                                </span>
                                <h3 className="mt-5 text-lg font-semibold leading-snug text-ink">{s[lang].name}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-mist">{s[lang].desc}</p>
                            </article>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.15} className="mt-10 flex flex-wrap gap-3">
                    <a
                        href="#appointment"
                        data-testid="services-book-cta"
                        className="inline-flex min-h-[48px] items-center rounded-full bg-gold-500 px-7 text-sm font-semibold text-ink shadow-[0_14px_30px_-12px_rgba(178,143,55,0.55)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold-600 active:scale-95"
                    >
                        {t.ctas.book}
                    </a>
                    <a
                        href={`https://wa.me/${WHATSAPP_NUMBER}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="services-whatsapp-cta"
                        className="inline-flex min-h-[48px] items-center gap-2 rounded-full border border-pine/25 px-7 text-sm font-semibold text-pine transition-[border-color,color,transform] duration-300 hover:-translate-y-0.5 hover:border-gold-500 hover:text-gold-600 active:scale-95"
                    >
                        <IconWhatsApp className="h-4 w-4" />
                        {t.ctas.whatsapp}
                    </a>
                </Reveal>
            </div>
        </section>
    );
};

export default ServicesSection;
